import React from 'react';

import { TableRowProps } from './TableRow';
export interface TableBodyProps
  extends React.HTMLProps<HTMLTableSectionElement> {
  /** Child of `Table.Body` which should be one or more `Table.Row`. */
  children:
    | React.ReactElement<TableRowProps>
    | React.ReactElement<TableRowProps>[];
}

export const TableBody: React.FC<TableBodyProps> = ({ children, ...rest }) => (
  <tbody {...rest}>{children}</tbody>
);

TableBody.displayName = 'Table.Body';
export default TableBody;
